import React, { useState } from 'react';

import { NotificationManager } from "react-notifications";
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Backdrop from '@mui/material/Backdrop';
import { useLocation, useNavigate } from "react-router-dom";
import pdfIcon from "../../pages/myTalentCommunity/icons/pdf.svg";
import docIcon from "../../pages/myTalentCommunity/icons/doc.png";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CancelIcon from '@mui/icons-material/Cancel';
import Alert from '@mui/material/Alert';
import { BlobServiceClient } from '@azure/storage-blob';
import SHA256 from 'crypto-js/sha256';
import Button from '@mui/material/Button';
import { DateTime } from "luxon";
import uploadResumeLogs from '../../apis/uploadResumeLogs/uploadResumeLogs';
const jsonConfig = require("../../Config.json");
const stylesSX = {
  backdrop: {
    zIndex: 1302,
    color: '#fff',
  },
  text: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    fontFamily: '"Segoe UI Semibold", sans-serif',
    fontWeight: 'bold',
    fontSize: "10px",
    color: "#ffffff",
    textShadow: "0px 1px 2px black",
  }
};

const modalStyles = {
  header: {
    background: 'linear-gradient(90deg, #1885E6 0%, #31B3F8 100%)',
    color: '#fff',
    padding: '24px 32px 16px 32px',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    fontSize: '22px',
    fontWeight: 600,
    fontFamily: '"Segoe UI Semibold", sans-serif',
    letterSpacing: '0.5px',
  },
  info: {
    backgroundColor: '#F6F6F6',
    borderRadius: '6px',
    padding: '15px',
    margin: '24px 0 32px 0',
    fontSize: '14px',
    color: '#000',
    fontFamily: '"Segoe UI", sans-serif',
    fontWeight: 400,
    textAlign: 'left',
  },
  chooseBtn: {
    display: 'block',
    margin: '0 auto 8px auto',
    padding: '12px 32px',
    background: '#fff',
    color: '#1885E6',
    border: '1.5px solid #1885E6',
    borderRadius: '6px',
    fontSize: '18px',
    fontWeight: 500,
    cursor: 'pointer',
    boxShadow: 'none',
    transition: 'background 0.2s',
    position: 'relative'
  },
  inputFile: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    opacity: 0,
    cursor: 'pointer'
  },
  caution: {
    textAlign: 'center',
    color: '#bdbdbd',
    fontWeight: 600,
    margin: '8px 0 24px 0',
    fontSize: '16px',
  },
  gridContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    justifyContent: 'center',
    marginBottom: '16px',
  },
  gridItem: {
    display: 'flex',
    alignItems: 'center',
    background: '#F6F6F6',
    borderRadius: '6px',
    padding: '8px 16px',
    minWidth: '180px',
    maxWidth: '220px',
  },
  fileIcon: {
    marginRight: '8px',
    display: 'flex',
    alignItems: 'center'
  },
  fileDesc: {
    flex: 1,
    fontSize: '14px',
    color: '#333',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  closeIcon: {
    marginLeft: '8px',
    color: '#888',
    cursor: 'pointer',
  },
  sourceDiv: {
    flex: 1,
    marginRight: '24px',
  },
  resumeSource: {
    fontWeight: 600,
    fontSize: '16px',
    marginBottom: '6px',
    color: '#333',
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'center',
    gap: '16px',
    marginTop: '24px',
    marginBottom: '8px',
  },
  uploadBtn: {
    background: '#1885E6',
    color: '#fff',
    borderRadius: '6px',
    fontWeight: 600,
    fontSize: '16px',
    padding: '8px 32px',
    boxShadow: 'none',
    border: 'none',
    height: '47px',
    width: '140px',
  },
  cancelBtn: {
    background: '#fff',
    color: '#1885E6',
    border: '1.5px solid #1885E6',
    borderRadius: '6px',
    fontWeight: 600,
    fontSize: '16px',
    padding: '8px 32px',
    height: '47px',
    width: '140px',
    boxShadow: 'none',
  },
};

const UploadResumeModal = (props) => {
    const history = useNavigate();

  const [progressOpen, setProgressOpen] = useState(false)
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState({ text: '', visible: false });
  const [backDropOpen, setBackDropOpen] = useState(false);

  const { sendDataToActivityModal, handleResumeLoader, activityModalUsed } = props;

  const {
    showResumeModal,
    setShowResumeModal,
    id,
    userRecruitmentpartnerId
  } = props;




  const idContextTest = id;
  const [sourceResume, setSourceResume] = useState("");

  function sanitizeFileName(fileName) {
    const lastDotIndex = fileName.lastIndexOf('.');
    const nameWithoutExt = lastDotIndex !== -1 ? fileName.substring(0, lastDotIndex) : fileName;
    const extension = lastDotIndex !== -1 ? fileName.substring(lastDotIndex) : '';
    const sanitizedName = nameWithoutExt
      .replace(/[^a-zA-Z0-9]/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
    const finalName = sanitizedName || 'resume';
    return finalName + extension;
  }

  const normalizeFileName = (name) =>
    name.toLowerCase().trim().replace(/\.[^/.]+$/, '').replace(/[^a-z0-9]/g, '');

  const getShortFileName = (fullName) => {
    const parts = fullName.split('.');
    const extension = parts.pop();
    const baseName = parts.join('.');
    const shortBase = baseName.length > 30 ? baseName.slice(0, 30) + '..' : baseName;
    return `${shortBase}.${extension}`;
  };



  const closeEditModal = () => {
    setShowResumeModal(false);
    setSelectedFiles([]);
    setErrorMessage('');
  };


  const handleFileChange = (event) => {

    const { files } = event.target;

    const allowedExtensions = ['pdf', 'doc', 'docx'];
    let selectedFilesArray = props?.singleFileSelect ? [] :
      Array.isArray(selectedFiles) ? [...selectedFiles] : [];

    for (let i = 0; i < files.length; i += 1) {
      const fileExtension = files[i].name.split('.').pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        setErrorMessage({ text: 'Only PDF and DOC files are allowed.', visible: true });
        setTimeout(() => {
          setErrorMessage({ text: '', visible: false });
        }, 5000);
        return;
      }

      if (selectedFilesArray.length + 1 > 5) {
        setErrorMessage({ text: 'You can only select up to 5 files.', visible: true });
        setTimeout(() => {
          setErrorMessage({ text: '', visible: false });
        }, 5000);
        return;
      }

      const isDuplicate = selectedFilesArray.some(
        (file) => normalizeFileName(file.name) === normalizeFileName(files[i].name)
      );
      if (isDuplicate) {
        setErrorMessage({ text: `File "${getShortFileName(files[i].name)}" is already added.`, visible: true });
        setTimeout(() => {
          setErrorMessage({ text: '', visible: false });
        }, 5000);
        return;
      }

      const sanitizedFileName = sanitizeFileName(files[i].name);
      if (!sanitizedFileName || sanitizedFileName.trim() === '') {
        setErrorMessage({ text: `File "${files[i].name}" has an invalid name that cannot be processed.`, visible: true });
        setTimeout(() => {
          setErrorMessage({ text: '', visible: false });
        }, 5000);
        return;
      }

      const sanitizedFile = new File([files[i]], sanitizedFileName, {
        type: files[i].type,
        lastModified: files[i].lastModified
      });
      sanitizedFile.originalName = files[i].name;

      selectedFilesArray.push(sanitizedFile);
    }

    setErrorMessage({ text: '', visible: false });
    setSelectedFiles(selectedFilesArray);
  };

  const getFileIcon = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();

    if (extension === 'pdf') {
      return <img src={pdfIcon} alt="PDF Icon" className="custom-icon" />;
    } else if (extension === 'doc' || extension === 'docx') {
      return <img src={docIcon} alt="DOC Icon" className="custom-icon" />;
    } else {
      return <InsertDriveFileIcon />;
    }
  };

  const removeSelectedFile = (index) => {
    const updatedSelectedFiles = [...selectedFiles];
    updatedSelectedFiles.splice(index, 1);
    setSelectedFiles(updatedSelectedFiles);
  }


  const uploadResumeToBlobStorage = async (filesArray) => {
    if (filesArray.length === 0) {
      setErrorMessage({ text: 'Select a file first.', visible: true });
      setTimeout(() => {
        setErrorMessage({ text: '', visible: false });
      }, 5000);
      return;
    }

    if (sourceResume === "") {
      NotificationManager.error("Source field can not be blank", "Error", 2000);
      return;
    }

    if (activityModalUsed) {
      handleResumeLoader(true);
    }

    setBackDropOpen(true);
    closeEditModal();
    setProgressOpen(true);

    try {


      const sas = decodeURI(jsonConfig.sasResumeToken);


      const bsClient = new BlobServiceClient(
        `https://${jsonConfig.blobStorageResumeAccountName}.blob.core.windows.net${sas}`
      );
      
      await uploadResumeLogs({
        userId: localStorage.getItem('userID'),
        recruitementPartnerId: userRecruitmentpartnerId
      });

      const containerClient = bsClient.getContainerClient("staging");
      if (userRecruitmentpartnerId) {
        let filnameWithtimearr = []

        const uploadPromises = filesArray.map(async (blob) => {
          let date = DateTime.now();
          let currentDate = date.toFormat("yyyy-MM-dd");
          let formattedDate = date.toFormat("yyyy-MM-dd'T'HH:mm:ss.SSSZZ");
          var v = blob.name.split(".");
          let uuid = create_UUID();
          let hashUuid = hash_UUID(uuid);
          let sanitizedOriginalName = sanitizeFileName(blob.name);
          let blobName = currentDate + "/" + idContextTest + "/" + hashUuid + "." + v[v.length - 1];
          const blobClient = containerClient.getBlockBlobClient(blobName);
          const blobUploadOptions = {
            blobHTTPHeaders: {
              blobContentType: blob.type,
            },
            metadata: {
              "createdtime": formattedDate,
              "fullname": sanitizedOriginalName,
              "originalname": blob.originalName || blob.name,
              "uploadedtype": "Recruiter Upload",
              "organizationid": userRecruitmentpartnerId,
              "blobfilename": blobName,
              "source": sourceResume
            },
          };

          const fileData = {
            "blobfilename": blobName,
            "createdtime": formattedDate,
            "organizationid": userRecruitmentpartnerId,
            "userRecruitmentpartnerId": userRecruitmentpartnerId,
            "userId": id,
            'URL': `https://${jsonConfig.blobStorageResumeAccountName}.blob.core.windows.net/staging/${blobName}`
          };

          await blobClient.uploadBrowserData(blob, blobUploadOptions);
          return fileData;
        });

        filnameWithtimearr = await Promise.all(uploadPromises);

        setProgressOpen(false)
        setBackDropOpen(false)

        if (activityModalUsed) {
          sendDataToActivityModal(filnameWithtimearr);
          handleResumeLoader(false)
        } else {
          const uploadData = {
            uploadedFiles: filnameWithtimearr,
            candidateId: idContextTest,
            timestamp: Date.now()
          };
          const encodedData = btoa(JSON.stringify(uploadData));
          sessionStorage.setItem('uploadedResumeData', encodedData);
          window.open('/pending-resume-validations?active=true', '_blank');
        }

      }




      setSelectedFiles([]);
      NotificationManager.success("Thank you! Your resumes are being uploaded and will be available shortly", "Success", 10000);
    } catch (error) {
      setSelectedFiles([]);
      setProgressOpen(false);
      setBackDropOpen(false);
      if (activityModalUsed) {
        handleResumeLoader(false);
      }
      NotificationManager.error("Failed to upload resume. Please try again.", "Error", 5000);
    }
  };

  function create_UUID() {
    let dt = new Date().getTime();
    const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt >>>= 4;
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      }
    );
    return uuid;
  }

  function hash_UUID(uuid) {
    return SHA256(uuid).toString();
  }


  return (
    <div>
      <Dialog
        onClose={!progressOpen ? closeEditModal : ''}
        aria-labelledby="customized-dialog-title"
        open={showResumeModal}
        PaperProps={{ style: { borderRadius: '8px', overflow: 'visible' } }}
        fullWidth
      >
        <div style={modalStyles.header}>Upload Resume</div>
        <DialogContent className='choose_file_dialog_content'>
          <>
            <div style={modalStyles.info}>
              After the resume is uploaded, redirect to the pending resume validation page to review the parsed resume details, fill in any missing fields, and complete the validation process. This ensures that if the candidate is already associated with any ongoing requisition, the hiring process is not disrupted.
            </div>
            <div className="choose_file_dialog">
              <button style={modalStyles.chooseBtn}>
                {props?.singleFileSelect ? "Choose File" : "Choose Files"}
                <input
                  type='file'
                  name='myFiles'
                  onChange={handleFileChange}
                  multiple={!props?.singleFileSelect}
                  accept=".pdf, .docx, .doc, application/pdf"
                  style={modalStyles.inputFile}
                />
              </button>
            </div>
            <div style={modalStyles.caution}>
              PDF or doc
            </div>

            <div style={modalStyles.gridContainer}>
              {selectedFiles.map((file, index) => (
                <div style={modalStyles.gridItem} key={index}>
                  <span style={modalStyles.fileIcon}>
                    {getFileIcon(file.name)}
                  </span>
                  <span style={modalStyles.fileDesc}>
                    {file.name}
                  </span>
                  <IconButton style={modalStyles.closeIcon} onClick={() => removeSelectedFile(index)}>
                    <CancelIcon />
                  </IconButton>
                </div>
              ))}
            </div>
            {errorMessage.visible && <Alert severity="error">{errorMessage.text}</Alert>}
          </>
        </DialogContent>
        {!progressOpen ? <>
          <Grid item xs={12} md={12} className="user_pop_button">
            <DialogActions style={modalStyles.actionButtons}>
              <div style={modalStyles.sourceDiv}>
                <Typography style={modalStyles.resumeSource}>Source*</Typography>
                <TextField
                  id="standard-basic"
                  variant="filled"
                  disabled={selectedFiles.length === 0}
                  onChange={(e) => { setSourceResume(e.target.value) }}
                />
              </div>
              <Button
                variant="contained"
                color="primary"
                className='upload_button'
                onClick={(e) => { uploadResumeToBlobStorage(selectedFiles) }}
                style={{ ...modalStyles.uploadBtn, color: '#fff' }}
              >
                Upload
              </Button>
              <Button
                variant="outlined"
                color="primary"
                className='cancel_button'
                onClick={closeEditModal}
                style={modalStyles.cancelBtn}
              >
                Cancel
              </Button>
            </DialogActions>
          </Grid>
        </>
          : null}
      </Dialog>
      <Backdrop style={stylesSX.backdrop} open={backDropOpen}>
        <CircularProgress color="inherit" className="circularprogress_mytalent" />
        <Typography style={stylesSX.text} variant="h6">Uploading Resume</Typography>
      </Backdrop>
    </div>
  )
}

export default UploadResumeModal